import React from 'react';
import { useNavigate } from 'react-router-dom';
import footerLogo from '../assets/logonobg.png';

const SHOP_LINKS = [
  { label: 'Living Room',      master: 'Living Room',      sub: 'TV Console & Storage' },
  { label: 'Bedroom',          master: 'Bedroom',          sub: 'Bedside Tables' },
  { label: 'Dining Area',      master: 'Dining Area',      sub: 'Storage & Bar Cabinets' },
  { label: 'Office Furniture', master: 'Office Furniture', sub: 'Office Desk & Chairs' },
  { label: 'Outdoor Furniture',master: 'Outdoor',          sub: 'Outdoor Lounge Sets' },
];

const SERVICE_LINKS = [
  { label: 'Custom Furniture',   page: 'custom-furniture' },
  { label: 'Virtual Showroom',   page: 'virtual-showroom' },
  { label: '2D and 3D Design',   page: '2d-3d-design' },
  { label: 'Free Consultation',  page: 'free-consultation' },
  { label: 'Delivery & Assembly',page: 'delivery-assembly' },
];

const COMPANY_LINKS = [
  { label: 'About Us',      page: 'about' },
  { label: 'Gallery',       page: 'gallery' },
  { label: 'Help Centre',   page: 'help-centre' },
  { label: 'Term of Sale',  page: 'termofsale' },
  { label: 'Contact Us',    page: 'contact' },
];

const CERTIFICATIONS = ['DTI Registered', 'PhilGEPS', 'ISO 9001'];

const Footer = () => {
  const navigate = useNavigate();
  const go = (page, params) => {
    if (page === 'product-list') {
      navigate(`/products?master=${encodeURIComponent(params.masterCategory)}&sub=${encodeURIComponent(params.subCategory)}`);
    } else {
      const pageMap = {
        'virtual-showroom': '/design-your-own',
        '2d-3d-design': '/design-your-own',
        'about': '/about',
        'gallery': '/gallery',
        'help-centre': '/help-centre',
        'termofsale': '/term-of-sale',
        'contact': '/contact',
        'custom-furniture': '/custom-furniture-request',
        'free-consultation': '/contact',
        'delivery-assembly': '/term-of-sale'
      };
      navigate(pageMap[page] || '/');
    }
  };

  const css = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=Montserrat:wght@300;400;500;600;700&display=swap');

    .site-footer * { box-sizing: border-box; }
    .site-footer {
      width: 100%;
      background: #1B2C22;
      color: #ffffff;
      font-family: 'Montserrat', sans-serif;
      padding: clamp(40px, 6vw, 64px) clamp(20px, 6vw, 80px) 28px;
      margin-top: auto;
    }
    .footer-grid {
      display: grid;
      grid-template-columns: 1.6fr 1fr 1fr 1fr;
      gap: clamp(20px, 4vw, 56px);
      max-width: 1300px;
      margin: 0 auto clamp(32px, 5vw, 48px);
    }

    /* ── BRAND COLUMN ── */
    .footer-brand-row {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 18px;
    }
    .footer-logo-box {
      width: 50px;
      height: 50px;
      border-radius: 6px;
      background: #1B2C22;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      flex-shrink: 0;
    }
    .footer-logo-img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .footer-brand-name {
      font-family: 'Cormorant Garamond', serif;
      font-size: 19px;
      font-weight: 700;
      color: #ffffff;
      line-height: 1.1;
    }
    .footer-brand-sub {
      font-family: 'Montserrat', sans-serif;
      font-size: 9px;
      font-weight: 600;
      letter-spacing: 2.5px;
      color: #AE8B59;
      margin-top: 2px;
    }
    .footer-desc {
      font-size: 13px;
      font-weight: 300;
      color: rgba(255,255,255,0.68);
      line-height: 1.75;
      max-width: 320px;
      margin-bottom: 22px;
    }
    .footer-label {
      font-family: 'Montserrat', sans-serif;
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 2.5px;
      text-transform: uppercase;
      color: #AE8B59;
      margin-bottom: 12px;
    }
    .footer-badges {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 30px;
    }
    .footer-badge {
      border: 1px solid rgba(255,255,255,0.28);
      border-radius: 3px;
      padding: 6px 10px;
      font-size: 10px;
      font-weight: 600;
      letter-spacing: 0.3px;
      color: rgba(255,255,255,0.85);
      white-space: nowrap;
    }
    .footer-showroom-desc {
      font-size: 13px;
      font-weight: 300;
      color: rgba(255,255,255,0.68);
      line-height: 1.75;
      max-width: 340px;
      margin-bottom: 10px;
    }
    .footer-showroom-download {
      font-size: 13px;
      font-weight: 300;
      color: rgba(255,255,255,0.68);
    }
    .footer-showroom-btn {
      background: none;
      border: none;
      padding: 0;
      color: #ffffff;
      font-family: 'Montserrat', sans-serif;
      font-size: 13px;
      font-weight: 600;
      text-decoration: underline;
      cursor: pointer;
      /* Remove forced min-height for inline text buttons */
      min-height: auto;
      min-width: auto;
    }
    .footer-showroom-btn:hover { color: #DEC731; }

    /* ── LINK COLUMNS ── */
    .footer-col-title {
      font-family: 'Montserrat', sans-serif;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 2px;
      text-transform: uppercase;
      color: #ffffff;
      margin-bottom: 20px;
    }
    .footer-link-btn {
      display: block;
      width: 100%;
      text-align: left;
      background: none;
      border: none;
      padding: 4px 0;
      margin-bottom: 0.5px;
      font-family: 'Montserrat', sans-serif;
      font-size: 13.5px;
      font-weight: 300;
      color: rgba(255,255,255,0.72);
      cursor: pointer;
      transition: color 0.2s ease;
      min-height: 36px;
      min-width: auto;
    }
    .footer-link-btn:hover { color: #DEC731; }

    /* ── BOTTOM BAR ── */
    .footer-bottom {
      border-top: 1px solid rgba(255,255,255,0.14);
      padding-top: 20px;
      max-width: 1300px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;
    }
    .footer-copyright {
      font-size: 12.5px;
      font-weight: 300;
      color: rgba(255,255,255,0.55);
    }
    .footer-bottom-links {
      display: flex;
      gap: 24px;
      flex-wrap: wrap;
    }
    .footer-bottom-btn {
      background: none;
      border: none;
      padding: 0;
      font-family: 'Montserrat', sans-serif;
      font-size: 12.5px;
      font-weight: 300;
      color: rgba(255,255,255,0.55);
      cursor: pointer;
      transition: color 0.2s ease;
      min-height: auto;
      min-width: auto;
    }
    .footer-bottom-btn:hover { color: #ffffff; }

    @media (max-width: 1024px) {
      .footer-grid { grid-template-columns: 1fr 1fr; }
    }
    @media (max-width: 640px) {
      .footer-grid { grid-template-columns: 1fr; }
      .footer-bottom { flex-direction: column; align-items: flex-start; }
    }
  `;

  return (
    <>
      <style>{css}</style>
      <footer className="site-footer">
        <div className="footer-grid">

          {/* ── BRAND ── */}
          <div>
            <div className="footer-brand-row">
              <div className="footer-logo-box">
                <img src={footerLogo} alt="Ukit Kapampangan logo" className="footer-logo-img" width="150" height="40" loading="lazy" />
              </div>
              <div>
                <div className="footer-brand-name">UKIT</div>
                <div className="footer-brand-sub">KAPAMPANGAN</div>
              </div>
            </div>

            <p className="footer-desc">
              Handcrafted premium furniture made by skilled Kapampangan artisans. Built with quality wood, designed for every Filipino home.
            </p>

            <div className="footer-label">Certified Quality</div>
            <div className="footer-badges">
              {CERTIFICATIONS.map(cert => (
                <span key={cert} className="footer-badge">{cert}</span>
              ))}
            </div>

            <div className="footer-label">Virtual Showroom</div>
            <p className="footer-showroom-desc">
              We created a Virtual Showroom so you can explore and visualize our furniture collections in a way that feels easy, interactive, and designed for you.
            </p>
            <p className="footer-showroom-download">
              Download Mobile Application{' '}
              <button
                type="button"
                className="footer-showroom-btn"
                onClick={() => go('virtual-showroom')}
              >
                HERE
              </button>
            </p>
          </div>

          {/* ── SHOP ── */}
          <div>
            <div className="footer-col-title">Shop</div>
            {SHOP_LINKS.map(link => (
              <button
                key={link.label}
                type="button"
                className="footer-link-btn"
                onClick={() => go('product-list', { masterCategory: link.master, subCategory: link.sub })}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* ── SERVICES ── */}
          <div>
            <div className="footer-col-title">Services</div>
            {SERVICE_LINKS.map(link => (
              <button
                key={link.label}
                type="button"
                className="footer-link-btn"
                onClick={() => go(link.page)}
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* ── COMPANY ── */}
          <div>
            <div className="footer-col-title">Menu</div>
            {COMPANY_LINKS.map(link => (
              <button
                key={link.label}
                type="button"
                className="footer-link-btn"
                onClick={() => go(link.page)}
              >
                {link.label}
              </button>
            ))}
          </div>

        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">© 2025 Ukit Kapampangan. All rights reserved.</div>
          <div className="footer-bottom-links">
            <button type="button" className="footer-bottom-btn" onClick={() => go('privacy-policy')}>Privacy Policy</button>
            <button type="button" className="footer-bottom-btn" onClick={() => go('terms-of-service')}>Terms of Service</button>
            <button type="button" className="footer-bottom-btn" onClick={() => go('sitemap')}>Sitemap</button>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;